import { createContext, useContext } from 'react';
import { IdentificationFormSteps, TInfoModal } from '../types';

type TIdentificationFormContextState = {
  isFormDirty: boolean;
  setIsFormDirty: React.Dispatch<React.SetStateAction<boolean>>;
  infoModal: TInfoModal;
  setInfoModal: React.Dispatch<React.SetStateAction<TInfoModal>>;
  defaultModalInfo: TInfoModal;
  targetForm: IdentificationFormSteps | null;
  setTargetForm: React.Dispatch<React.SetStateAction<IdentificationFormSteps | null>>;
};

export const IdnetificationFormContext = createContext<TIdentificationFormContextState | undefined>(
  undefined
);

export const useIdentificationFormContext = () => useContext(IdnetificationFormContext)!;
